import React, { useState, useMemo } from 'react';
import { 
    Input, 
    Select, 
    Space, 
    Button, 
    Badge, 
    Checkbox, 
    Dropdown,
    Tooltip 
} from 'antd';
import { 
    SearchOutlined, 
    FilterOutlined, 
    ClearOutlined,
    SortAscendingOutlined 
} from '@ant-design/icons';

const { Search } = Input;
const { Option } = Select;

const ChecklistFilters = ({ 
    checklists = [], 
    onFilter, 
    onSort,
    searchValue = '',
    filters = {},
    sortBy = 'name'
}) => {
    const [activeFiltersCount, setActiveFiltersCount] = useState(0);
    const [localSearchValue, setLocalSearchValue] = useState(searchValue);

    
    useMemo(() => {
        let count = 0;
        if (filters.hasCustomFields !== undefined) count++;
        if (filters.hasAmoFields !== undefined) count++;
        if (filters.hasSyncedFields !== undefined) count++;
        if (searchValue) count++;
        setActiveFiltersCount(count);
    }, [filters, searchValue]);

    const handleSearch = (value) => {
        setLocalSearchValue(value);
        onFilter?.({ ...filters, search: value });
    };



    const handleFieldTypeFilter = (key, checked) => {
        onFilter?.({ ...filters, [key]: checked ? true : undefined });
    };

    const clearAllFilters = () => {
        setLocalSearchValue('');
        onFilter?.({});
    };



    const sortOptions = [
        { label: 'По названию', value: 'name' },
        { label: 'По количеству полей', value: 'fieldCount' },
        { label: 'По дате создания', value: 'created' }
    ];

    const fieldFiltersMenu = {
        items: [
            {
                key: 'hasCustomFields',
                label: (
                    <Checkbox
                        checked={filters.hasCustomFields}
                        onChange={(e) => handleFieldTypeFilter('hasCustomFields', e.target.checked)}
                    >
                        Есть кастомные поля
                    </Checkbox>
                )
            },
            {
                key: 'hasAmoFields',
                label: (
                    <Checkbox
                        checked={filters.hasAmoFields}
                        onChange={(e) => handleFieldTypeFilter('hasAmoFields', e.target.checked)}
                    >
                        Есть AMO поля
                    </Checkbox>
                )
            },
            {
                key: 'hasSyncedFields',
                label: (
                    <Checkbox
                        checked={filters.hasSyncedFields}
                        onChange={(e) => handleFieldTypeFilter('hasSyncedFields', e.target.checked)}
                    >
                        Есть синхронизированные поля
                    </Checkbox>
                )
            }
        ]
    };

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Space wrap>
                <Search
                    placeholder="Поиск по названию чеклиста..."
                    value={localSearchValue}
                    onChange={(e) => setLocalSearchValue(e.target.value)}
                    onSearch={handleSearch}
                    style={{ width: 250 }}
                    allowClear
                />



                <Dropdown menu={fieldFiltersMenu} trigger={['click']}>
                    <Button icon={<FilterOutlined />}>
                        Типы полей
                        {(filters.hasCustomFields || filters.hasAmoFields || filters.hasSyncedFields) && (
                            <Badge 
                                count={[filters.hasCustomFields, filters.hasAmoFields, filters.hasSyncedFields].filter(Boolean).length} 
                                size="small"
                                style={{ marginLeft: 4 }}
                            />
                        )}
                    </Button>
                </Dropdown>

                <Select
                    value={sortBy}
                    onChange={onSort}
                    style={{ width: 150 }}
                    suffixIcon={<SortAscendingOutlined />}
                >
                    {sortOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>

                {activeFiltersCount > 0 && (
                    <Tooltip title="Сбросить все фильтры">
                        <Button 
                            icon={<ClearOutlined />} 
                            onClick={clearAllFilters}
                        >
                            Сбросить
                            <Badge 
                                count={activeFiltersCount} 
                                size="small"
                                style={{ marginLeft: 4 }}
                            />
                        </Button>
                    </Tooltip>
                )}
            </Space>

            {activeFiltersCount > 0 && (
                <div style={{ fontSize: 12, color: '#8c8c8c' }}>
                    Показано {checklists.length} чеклистов с активными фильтрами
                </div>
            )}
        </Space>
    );
};

export default ChecklistFilters; 